import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-newpart",
  "use": "icon-newpart-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-newpart\">\r\n<style type=\"text/css\">\r\n\t#icon-newpart .st0{fill:'';}\r\n</style>\r\n<path class=\"st0\" d=\"M11.1,5.1H6.9V0.9C6.9,0.4,6.5,0,6,0S5.1,0.4,5.1,0.9v4.3H0.9C0.4,5.1,0,5.5,0,6s0.4,0.9,0.9,0.9h4.3v4.3\r\n\tC5.1,11.6,5.5,12,6,12s0.9-0.4,0.9-0.9V6.9h4.3C11.6,6.9,12,6.5,12,6S11.6,5.1,11.1,5.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol